import React from 'react';
import { useTranslation } from 'react-i18next';
import type { MenuProps } from 'antd';
import { Flex, Typography } from 'antd';
import { FlagIcon } from '@evimo/components/flagIcon/FlagIcon';
import { CheckOutlined } from '@ant-design/icons';
import { Language } from '@evimo/types/enums/language';

const { Text } = Typography;

export const useLanguageSwitcher = () => {
  const { t, i18n } = useTranslation('common');

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    const value = e.key;
    localStorage.setItem('language', value);
    i18n.changeLanguage(value);
    document.documentElement.lang = value;
  };

  const languages: Array<{ key: Language; label: string }> = [
    { key: Language.EN, label: t('languages.en') },
    { key: Language.FR, label: t('languages.fr') },
  ];

  const items: MenuProps['items'] = languages.map((lang) => ({
    key: lang.key,
    label: (
      <Flex
        align="center"
        gap={10}
        style={{
          padding: '8px 12px',
          width: 'max-content',
          color: 'inherit',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        <Flex align="center" justify="center" style={{ width: 16 }}>
          {i18n.language.toUpperCase() === lang.key && (
            <CheckOutlined style={{ fontSize: 14 }} />
          )}
        </Flex>
        <FlagIcon language={lang.key} />
        <Text style={{ fontSize: '14px' }}>{lang.label}</Text>
      </Flex>
    ),
    style: { padding: 0 },
  }));

  const currentLanguage = (
    i18n.language.toUpperCase().startsWith('FR') ? Language.FR : Language.EN
  ) as Language;

  return {
    currentLanguage,
    items,
    handleMenuClick,
  };
};
